<template>
  <div class="p_resume_content">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">姓名</div>
                    <el-input v-model="listQuery.username" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                    <div class="flname">电话</div>
                    <el-input v-model="listQuery.strtel" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                  <el-tooltip class="scr_icon" effect="dark" content="更多检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">更多<i class="el-icon-caret-bottom"></i></i>
                  </el-tooltip>
                </div>
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="isCanHandle && tableData.length>0" type="primary" size="small" @click="exportHandle" :loading="btnLoading">导出</el-button>
            <el-button type="success" size="small" @click="searchHandle" style="margin-right:16px;">搜索</el-button>
        </div>
        <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen==1">
        <div class="res_drop_box">
          <el-form :inline="true" :model="listQuery" class="res_drop_form" label-width="100px">
            <el-form-item label="岗位:">
               <el-input v-model="listQuery.strjob" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="城市:">
               <el-input v-model="listQuery.strProCity" clearable></el-input>
            </el-form-item>
            <el-form-item label="年龄:">
               <el-input v-model="listQuery.strProCity" clearable></el-input>
            </el-form-item>
            <el-form-item label="性别:">
               <el-select v-model="listQuery.strProCity" placeholder="请选择性别" clearable>
                  <el-option label="" value="男">男</el-option>
                  <el-option label="" value="女">女</el-option>
                  <el-option label="" value="未知">未知</el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="期望薪资:">
               <el-input v-model="listQuery.strProCity" clearable></el-input>
            </el-form-item> -->
          </el-form>
        </div>
        <div class="drop-footer">
            <el-button size="small" plain @click="resetHandle()">清空</el-button>
            <el-button size="small" type="success" plain @click="searchHandle()">搜索</el-button>
            <el-button size="small" plain @click="showDropScreen=-1">关闭</el-button>
        </div>
      </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>花名册信息管理</el-breadcrumb-item>
            <el-breadcrumb-item>简历库</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
      <div class="p_roster_table">
        <el-table v-loading="tableLoading" :max-height="tableHeight-100" :data="tableData" style="width:100%" stripe >
          <!-- <el-table-column align="center" label="序号" width="60px">
            <template slot-scope="scope">
                <span>{{(listQuery.currpage - 1) * listQuery.perpage + scope.$index + 1}}</span>
              </template>
          </el-table-column> -->
          <template v-for="(item,index) in tableTitle">
             <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :key="index" :width="item.StrColumName=='备注' ? 380 : (item.StrColumName=='NO'? 60 : (item.StrColumName=='姓名'? 100 : 180)) " align="center" :fixed="item.StrColumName=='项目名称' || item.StrColumName=='姓名'">
              <template slot-scope="{row}">
                <span>{{row[item.StrColumId]}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="changeBPage"
            :current-page.sync="listQuery.currpage"
            :page-size="listQuery.perpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes,prev,pager, next, jumper"
            :total="total"
          ></el-pagination>
      </div>
      </div>
    </div>
     
  </div>
</template>

<script>
import xz from "@/common";
export default {
  name: "resumeList",
  data() {
    return {
      btnLoading:false,
        // 客户等级
        levelList:[],
        // 客户行业
        industryList:[],
        // 业务部门
        departmentList:[],
        // 列表参数
        listQuery:{
          currpage:1,
          perpage:10,
          roletype:'',
          username:'', // 姓名
          strtel:'', //电话
          strcity:'', //城市
          strjob:'' //岗位
        },
        tableTitle:[],
      tableHeight:0,
      tableLoading:false,
      tableData:[],
      total:0,
      //下拉筛选
      showDropScreen: -1,
      // 导出参数
      exportQuery:{
        roletype:'',
        username:'', // 姓名
        strtel:'', //电话
        strcity:'', //城市
        strjob:'', //岗位
        tableid:'JB_emp_Resume_out'
      },
      // 按钮权限参数
        butQuery:{
          roletype:'',
          page:'customList'
        },
        // 是否有权限操作按钮
        isCanHandle:false
    }
  },
  created() {
    this.butQuery.roletype = localStorage.loginRoletype
    this.listQuery.roletype = localStorage.loginRoletype
    this.getButtonPower()
      this.calHeight()
      this.getTableTitle()
  },
  methods: {
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
      // console.log('height',this.tableHeight) 
    },
    // 获取列表表头
    getTableTitle(){
      xz.getJbPageColumnDefList('JB_emp_Resume').then(res => {
        // console.log('表头', res)
        if (res.status == 'ok') {
          this.tableTitle = res.msg
          this.getList()
        } else {
          this.tableTitle = []
        }
      })
    },
    // 获取列表
    getList(){
      this.tableLoading = true
      xz.getEmpResumeLists(this.listQuery).then(res => {
        // console.log('客户', res)
        if (res.status == 'ok') {
          this.tableData = res.msg
          this.total = res.totalcount
        } else {
          this.tableData = []
          this.total = 0
        }
        this.tableLoading = false
      })
    },
    // 获取按钮权限
    getButtonPower(){
      xz.getJbUserRolepageDetail(this.butQuery.roletype, this.butQuery.page).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let powerVal  = res.msg[0].Buttons
          if(powerVal == 'search'){
            // 只能查看
            this.isCanHandle = false
          }else if(powerVal == 'update'){
            // 特殊处理 只能更改客服
            this.isCanHandle = false
          }else if(powerVal == 'operation'){
            // 可操作
            this.isCanHandle = true
          }
        }else{
          this.isCanHandle = false
        }
      })
    },
    //判断是否为空(包含0)
    isNullDate(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "1900/01/01" ||
        o == "1900-01-01T00:00:00" ||
        o == "1900-01-01"
      )
    },
    // 搜索
    searchHandle(){
      this.listQuery.currpage = 1
      this.getList()
    },
    //分页
    changeBPage(val){
        this.listQuery.currpage = Number(val)
        this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1
        this.listQuery.perpage = Number(val)
        this.getList()
    },
    // 导出
    exportHandle(){
      this.btnLoading = true
      this.exportQuery.username = this.listQuery.username
      this.exportQuery.strtel = this.listQuery.strtel
      this.exportQuery.strcity = this.listQuery.strcity
       this.exportQuery.strjob = this.listQuery.strjob
       this.exportQuery.roletype = this.listQuery.roletype
      xz.getOutResumeUser(this.exportQuery).then(res => {
        // console.log('导出', res)
        if (res.status == 'ok') {
          // console.log('导出', data)
          this.$router.push({
            path: "/operationRecord",
            query: {
              showPage: 1,
              isActive: 1,
              custname: res.msg,
              //qStstus=1时查看最后一条导出记录
              qStstus: 1
            }
          })
        } else {
          this.$message({
            message: "导出失败，请稍后再试",
            type: "error"
          })
        }
        this.btnLoading = false
      })
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1
      }
    },
    //清空
    resetHandle() {
      this.listQuery = {
        xmName:'',
        oneName:'',
        fzkfName:'',
        ywbmName:'',
        pagecount: 10,
        currpage: 1
      }
    }
  }
};
</script>
<style>
.screenInputs
.scr_icon .el-icon-caret-bottom{
  font-size: 18px;
  color:#999;
  cursor: pointer;
}
.scr_icon.i_txt{
  display: inline-block;
  font-size: 12px;
  cursor: pointer;
}
.res_drop_form{
  margin-top: 8px;
}
.res_drop_form .el-form-item{
  margin-bottom: 3px;
}
.res_drop_form .el-input__inner{
  height: 32px;
  line-height: 32px;
}
.res_drop_form .el-select,.res_drop_form .el-form-item__content{
  width: 230px;
}
.p_resume_content .flname{
  text-align: right;
}
.p_resume_content .cus_dialog .el-select{
    width: 100%;
}
.p_resume_content .screenInput .el-input{
    width: 200px;
}
.screenInput .el-input .el-input__inner,
.screenInput .el-select .el-input__inner{
    height: 32px;
    line-height: 32px;
}
</style>
<style scoped>
.el-pagination{
  background-color: #fff;
}
.reset{
  height: 32px;
  padding: 5px 15px;
  border-radius: 5px;
  color:#B2BCB7;
  background-color: #fff;
  border: 1px solid #fff;
  margin-right: 10px;
}
.p-txt{
  color: rgba(0, 0, 0, 0.4);
}
</style>